import { render, staticRenderFns } from "./TemplateMe.vue?vue&type=template&id=011c5aa6"
import script from "./TemplateMe.vue?vue&type=script&lang=js"
export * from "./TemplateMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports